/**
 * Keys for the signed-in session's queries. `authenticated()` holds the account,
 * user and workspaces `useAuthQuery` loads, which the auth store mirrors.
 */
export const authKeys = {
  authenticated: () => ['authenticated'] as const,
  /** Every user on the account. The teammate profile, the masquerade banner, workspace setup and audit logs share it. */
  allUsers: (accountId: number) => ['getAllUsers', { params: { account_id: accountId } }] as const,
};
